import sexytshirt from "../../../images/latestproducts/sexy_tshirt.jpg";
import sleevedress from "../../../images/latestproducts/Sleeve-dresse.jpg";
import skagenwatch from "../../../images/latestproducts/Skagen-watch.jpg";
import workoutspants from "../../../images/latestproducts/Workout-Pants.jpg";
import tshirt from "../../../images/latestproducts/t-shirt.jpg";
import nikeshoes from "../../../images/latestproducts/nikeshoes.jpg";
import menperfum from "../../../images/latestproducts/men_perfum.jpg";
import hoodi from "../../../images/latestproducts/hoodiesmen.jpg";

const ProductsData = [
  {
    image: sexytshirt,
    name: " sexy women T-shirt ",
    price: "$20.00 USD",
  },
  {
    image: sleevedress,
    name: "sleeve dresse",
    price: "$24.00 USD",
  },
  {
    image: skagenwatch,
    name: "cool skagen watch",
    price: "$14.00 USD",
  },
  {
    image: workoutspants,
    name: "workouts pants",
    price: "$19.99 USD",
  },
  {
    image: tshirt,
    name: "black men t-shirt",
    price: "$88.00 USD",
  },
  {
    image: nikeshoes,
    name: "new nike shoes",
    price: "$120.90 USD",
  },
  {
    image: menperfum,
    name: "men perfum",
    price: "$39.00 USD",
  },
  {
    image: hoodi,
    name: " men hoodi",
    price: "$19.99 USD",
  },
];

export default ProductsData;
